import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { EmailSettingComponent } from '../email-setting/email-setting.component';
import { EmailEmbedSettings } from '../email-settings.types';

@Component({
  standalone: true,
  imports: [CommonModule, EmailSettingComponent],
  selector: 'mode-email-embeds',
  templateUrl: './email-embeds.component.html',
  styleUrls: ['./email-embeds.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmailEmbedsComponent {
  @Input() selections!: EmailEmbedSettings;
  @Input() disableAttachments = false;
  @Output() embedsSelected = new EventEmitter<Partial<EmailEmbedSettings>>();
}
